import React, { useState, useEffect } from 'react';

const Header = ({ logo }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToPartner = () => {
    // Check if we're on homepage
    if (window.location.pathname === '/') {
      const partnerSection = document.getElementById('partner');
      if (partnerSection) {
        partnerSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to homepage with partner anchor
      window.location.href = '/#partner';
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-black/90 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Team Name - Left */}
          <div className="flex items-center">
            <a href="/" className="text-lg font-bold text-white tracking-wide hover:text-cyan-400 transition-colors">
              SevenMotorSport <span className="text-cyan-400">TM Factory Support</span>
            </a>
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a
              href="/campionati"
              className="text-white hover:text-cyan-400 transition-colors duration-300 font-semibold"
            >
              Campionati
            </a>
            <a
              href="/gare"
              className="text-white hover:text-cyan-400 transition-colors duration-300 font-semibold"
            >
              Gare
            </a>
            <a
              href="/calendario"
              className="text-white hover:text-cyan-400 transition-colors duration-300 font-semibold"
            >
              Calendario
            </a>
            <a
              href="/gallery"
              className="text-white hover:text-cyan-400 transition-colors duration-300 font-semibold"
            >
              Shooting
            </a>
            <button
              onClick={scrollToPartner}
              className="text-white hover:text-cyan-400 transition-colors duration-300 font-semibold"
            >
              Partner
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
